'use client';

import type { ReactNode } from 'react';
import { useCallback } from 'react';
import { TerminalCommandDisplay } from '../../TerminalContent';
import type { HITLContentContext } from '../../tool-config-types';

function TerminalContentRenderer({ ctx }: { ctx: HITLContentContext }) {
  const command = (ctx.args?.command as string) || '';

  const handleSave = useCallback(
    (editedCommand: string) => {
      ctx.onSave?.({ ...ctx.args, command: editedCommand });
    },
    [ctx],
  );

  return (
    <TerminalCommandDisplay
      command={command}
      isEditing={ctx.isEditing}
      onSave={handleSave}
      onCancel={ctx.onCancel}
    />
  );
}

export const renderTerminalContent = (ctx: HITLContentContext): ReactNode => (
  <TerminalContentRenderer ctx={ctx} />
);
